import { Routes } from '@angular/router';
import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout.component';
import { DefaultComponent } from './layouts/default/default.component';
import { LoginGuard, LogoutGuard } from './helper/guard/login.guard';
import { PermissionGuard } from './helper/guard/permission.guard';
import { UrlServices } from './helper/class/url-services';

export const routes: Routes = [
  {
    path: '',
    component: AuthLayoutComponent,
    children: [
      {
        path: '', 
        loadChildren: () => import('./core/module/Auth/Auth.module').then(m => m.AuthModule),
        canActivate: [LogoutGuard]
      },
    ]
  },
  {
    path: UrlServices.AUTH_PAGE.PUBLIC_STAFF_LEAVE_URL.split(/[/]+/).pop(),
    loadComponent: () => import('./core/component/public-staff-leave/public-staff-leave.component').then(m => m.PublicStaffLeaveComponent),
    canActivate: [LogoutGuard]
  },
  {
    path: '',
    component: DefaultComponent,
    children: [
      {
        canActivateChild: [PermissionGuard],
        path: '', 
        loadChildren: () => import('./modules/modules.module').then(m => m.ModulesModule),
        canActivate: [LoginGuard]
      },
    ]
  },
];
